import * as types from '../API/ActionTypes';
import InitialState from './initialState';

export function exportSensorListErrorReducer(state = InitialState.exportSensorListErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.EXPORT_SENSOR_LIST_ERROR:
			return action.exportSensorListErrorFlag;
		default:
			return state;
	}
}

export function exportSensorListLoadingReducer(state = InitialState.exportSensorListLoading, action) 
{
	switch (action.type) 
	{
		case types.EXPORT_SENSOR_LIST_LOADING:
			return action.exportSensorListLoading;
		default:
			return state;
	}
}

export function sensorListErrorReducer(state = InitialState.sensorOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_LIST_ERROR:
			return action.sensorOutputErrorFlag;
		default:
			return state;
	}
}

export function sensorListLoadingReducer(state = InitialState.sensorOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_LIST_LOADING:
			return action.sensorOutputDataLoading;
		default:
			return state;
	}
}

export function sensorListReducer(state = InitialState.sensorOutputData, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_LIST:
			return action.sensorOutputData;
		case types.ADD_LATEST_COMMENT_IN_SENSOR_LIST:
			var updatedSensorList = state.sensorList != undefined && state.sensorList.length > 0
										?
											state.sensorList.map(sensor => (
												sensor.assetId === action.comment.assetId
												?
													{
														...sensor,
														comment: action.comment.comment
													}
												:
													{
														...sensor
													}
											))
										:
											[];
			return {
				...state,
				sensorList: updatedSensorList
			}
		case types.UPDATE_SENSOR_UNRESPONSIVE_REASON:
			var updatedSensorList = state.sensorList != undefined && state.sensorList.length > 0
										?
											state.sensorList.map(sensor => (
												sensor.assetId === action.sensorUnresponsiveReason.assetId
												?
													{
														...sensor,
														sensorUnresponsiveReason: (action.sensorUnresponsiveReason.sensorUnresponsiveReason)
													}
												:
													{
														...sensor
													}
											))
										:
											[];
			return {
				...state,
				sensorList: updatedSensorList
			}
		default:
			return state;
	}
}

export function sensorHistoryForAnAssetErrorReducer(state = InitialState.sensorHistoryErrorFlag, action) 
{
	switch (action.type)
	{
		case types.SENSOR_HISTORY_ERROR:
			return action.sensorHistoryErrorFlag;
		default:
			return state;
	}
}

export function sensorHistoryForAnAssetLoadingReducer(state = InitialState.sensorHistoryLoading, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_HISTORY_LOADING:
			return action.sensorHistoryLoading;
		default:
			return state;
	}
}

export function sensorHistoryForAnAssetReducer(state = InitialState.sensorHistory, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_HISTORY:
			try
			{
				return {
					sensorHistory: action.sensorHistory
				}
			} catch(error)
			{
				console.log("Load sensor history", error);
			}
			break;
		default:
			return state;
	}
}

export function updateSensorUnresponsiveReasonErrorReducer(state = InitialState.updateSensorUnresponsiveReasonErrorFlg, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SENSOR_UNRESPONSIVE_REASON_ERROR:
			return action.updateSensorUnresponsiveReasonErrorFlg;
		default:
			return state;
	}
}

export function updateSensorUnresponsiveReasonLoadingReducer(state = InitialState.updateSensorUnresponsiveReasonLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_SENSOR_UNRESPONSIVE_REASON_LOADING:
			return action.updateSensorUnresponsiveReasonLoading;
		default:
			return state;
	}
}

export function sensorUnresponsiveReasonListErrorReducer(state = InitialState.sensorUnresponsiveReasonListErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_UNRESPONSIVE_REASON_LIST_ERROR:
			return action.sensorUnresponsiveReasonListErrorFlag;
		default:
			return state;
	}
}

export function sensorUnresponsiveReasonListLoadingReducer(state = InitialState.sensorUnresponsiveReasonListLoading, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_UNRESPONSIVE_REASON_LIST_LOADING:
			return action.sensorUnresponsiveReasonListLoading;
		default:
			return state;
	}
}

export function sensorUnresponsiveReasonListReducer(state = InitialState.sensorUnresponsiveReasonList, action) 
{
	switch (action.type) 
	{
		case types.SENSOR_UNRESPONSIVE_REASON_LIST:
			return action.sensorUnresponsiveReasonList;
		default:
			return state;
	}
}